import { Button, Modal, Form, Row, Col, message, Select } from "antd";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { handleAssignTrainingCourse } from "../../../api/training";
import { handleFetchCourses } from "../../../api/course";

const { Option } = Select;

export default function AssignCourse({
  isVisible,
  setVisible,
  training_id,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { data: courses } = useQuery({
    queryKey: ["courses"],
    queryFn: handleFetchCourses,
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: handleAssignTrainingCourse,
    onSuccess: () => {
      message.success("Created Successfully");
      form.resetFields();
      queryClient.invalidateQueries({
        queryKey: ["allTrainings", training_id],
      });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    const data = {
      ...values,
    };
    await mutate({ _id: training_id, data });
    setVisible(false);
  };

  const courseOptions = courses?.payload?.map((level: any, index: number) => (
    <Option value={level?._id} key={index}>
      {level?.name}
    </Option>
  ));

  const clearForm = async () => {
    form.resetFields();
  };

  return (
    <Modal
      open={isVisible}
      title="Assign Course"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="assignCourse"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="assignCourse"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-row, justify-between"></div>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="course"
              label="Course"
              rules={[
                {
                  required: true,
                  message: "Please enter course",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search to Select Vehicle"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {courseOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
